import { render } from "./FinancialYearQuarterSelector.vue?vue&type=template&id=5e791b70&scoped=true"
import script from "./FinancialYearQuarterSelector.vue?vue&type=script&lang=js"
export * from "./FinancialYearQuarterSelector.vue?vue&type=script&lang=js"

import "./FinancialYearQuarterSelector.vue?vue&type=style&index=0&id=5e791b70&lang=css&scoped=true"

import exportComponent from "D:\\a\\1\\s\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e791b70"]])

export default __exports__
import QOptionGroup from 'quasar/src/components/option-group/QOptionGroup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QOptionGroup});
